module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ../~/rc-switch/es/index.js
// module id = 1306
// module chunks = 0